<template>
  <div class="node-config">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="80px" size="small">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="基本信息" name="basic">
          <el-form-item label="节点编号" prop="node_no">
            <el-input v-model="form.node_no" placeholder="如: START, APPROVAL_1" />
          </el-form-item>

          <el-form-item label="节点名称" prop="node_name">
            <el-input v-model="form.node_name" placeholder="请输入节点名称" />
          </el-form-item>

          <el-form-item label="节点类型">
            <el-tag :type="getNodeTypeTag(form.node_type)">{{ getNodeTypeText(form.node_type) }}</el-tag>
          </el-form-item>

          <el-form-item label="操作类型" prop="action_type">
            <el-select
              v-model="form.action_type"
              placeholder="请选择"
              style="width: 100%"
              key="action-type-select"
              @change="handleActionTypeChange"
            >
              <el-option
                v-for="opt in actionTypeSelectOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="处理人类型" prop="handler_type">
            <el-select
              v-model="form.handler_type"
              placeholder="请选择处理人类型"
              style="width: 100%"
              @change="handleHandlerTypeChange"
            >
              <el-option label="指定角色" :value="1" />
              <el-option label="指定人员" :value="2" />
              <el-option label="发起人" :value="3" />
            </el-select>
          </el-form-item>

          <template v-if="form.handler_type === 1">
            <el-form-item label="处理角色" prop="handler_role_ids">
              <el-select
                v-model="selectedRoles"
                multiple
                placeholder="请选择角色"
                style="width: 100%"
                @change="handleRolesChange"
                :key="'role-select-' + form.action_type"
              >
                <el-option
                  v-for="role in rolesForHandlerSelect"
                  :key="role.id"
                  :label="role.name"
                  :value="role.id"
                />
              </el-select>
              <div v-if="isQuoteOrDispatchAction" class="form-tip">报价、派单节点仅可选择平台管理员</div>
            </el-form-item>
          </template>

          <template v-if="form.handler_type === 2">
            <el-form-item label="处理人员" prop="handler_user_ids">
              <el-select
                v-model="selectedUsers"
                multiple
                placeholder="请选择人员"
                style="width: 100%"
                @change="handleUsersChange"
              >
                <el-option
                  v-for="user in userOptions"
                  :key="user.id"
                  :label="user.name"
                  :value="user.id"
                />
              </el-select>
            </el-form-item>
          </template>

          <template v-if="form.handler_type === 8">
            <el-form-item label="处理人条件">
              <el-input
                v-model="form.handler_condition"
                type="textarea"
                :rows="3"
                placeholder="请输入JSON格式的条件"
              />
              <div class="form-tip">例如: {"department": "技术部", "level": "高级"}</div>
            </el-form-item>
          </template>

          <el-form-item label="时限(小时)">
            <el-input-number
              v-model="form.time_limit_hours"
              :min="0"
              :max="720"
              :step="1"
              placeholder="0表示不限时"
              style="width: 100%"
            />
            <div class="form-tip">超过时限会自动处理</div>
          </el-form-item>

          <el-form-item label="排序">
            <el-input-number
              v-model="form.sort"
              :min="1"
              :max="999"
              controls-position="right"
              style="width: 100%"
            />
          </el-form-item>

          <el-form-item label="下一节点" v-if="form.node_type !== 4">
            <el-select
              v-model="form.next_node_id"
              placeholder="请选择下一节点"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="node in availableNodes"
                :key="node.id"
                :label="node.node_name"
                :value="node.id"
              />
            </el-select>
            <div class="form-tip">结束节点无需设置下一节点</div>
          </el-form-item>
        </el-tab-pane>

        <el-tab-pane label="特殊要求" name="requirements">
          <el-form-item label="需要照片">
            <el-switch
              v-model="form.require_photos"
              :active-value="1"
              :inactive-value="0"
            />
          </el-form-item>

          <!-- <el-form-item label="需要付款">
            <el-switch
              v-model="form.require_payment"
              :active-value="1"
              :inactive-value="0"
              @change="handlePaymentChange"
            />
          </el-form-item>

          <template v-if="form.require_payment">
            <el-form-item label="付款类型">
              <el-select v-model="form.payment_type" placeholder="请选择" style="width: 100%">
                <el-option label="定金" :value="1" />
                <el-option label="进度款" :value="2" />
                <el-option label="尾款" :value="3" />
                <el-option label="全款" :value="4" />
              </el-select>
            </el-form-item>

            <el-form-item label="付款比例(%)">
              <el-input-number
                v-model="form.payment_percentage"
                :min="0"
                :max="100"
                :precision="2"
                :step="5"
                style="width: 100%"
              />
            </el-form-item>

            <el-form-item label="付款金额">
              <el-input-number
                v-model="form.payment_amount"
                :min="0"
                :precision="2"
                style="width: 100%"
              />
              <div class="form-tip">金额和比例二选一</div>
            </el-form-item>
          </template> -->

          <!-- <el-form-item label="需要报价">
            <el-switch
              v-model="form.require_quotation"
              :active-value="1"
              :inactive-value="0"
            />
          </el-form-item> -->

          <el-form-item label="允许的操作">
            <el-checkbox-group v-model="selectedActions">
              <el-checkbox :label="1">通过</el-checkbox>
              <el-checkbox :label="2">驳回</el-checkbox>
              <el-checkbox :label="3">转交</el-checkbox>
              <el-checkbox :label="4">撤回</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-tab-pane>

        <el-tab-pane label="备注说明" name="remark">
          <el-form-item class="remark-form-item">
            <el-input
              v-model="form.remark"
              type="textarea"
              :rows="4"
              placeholder="请输入节点备注说明"
            />
          </el-form-item>
        </el-tab-pane>
      </el-tabs>

      <div class="form-actions">
        <el-button type="primary" @click="handleSubmit" size="small">保存配置</el-button>
        <el-button @click="handleReset" size="small">重置</el-button>
        <el-button type="danger" @click="handleDelete" size="small" v-if="isEdit">删除节点</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'NodeConfig',

  props: {
    node: {
      type: Object,
      required: true
    },
    processId: {
      type: Number,
      required: true
    },
    allNodes: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      form: {},
      activeTab: 'basic',
      selectedRoles: [],
      selectedUsers: [],
      selectedActions: [],

      roleOptions: [],
      userOptions: [],

      rules: {
        node_no: [
          { required: true, message: '请输入节点编号', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9_]+$/, message: '只能包含字母、数字和下划线', trigger: 'blur' }
        ],
        node_name: [
          { required: true, message: '请输入节点名称', trigger: 'blur' }
        ],
        action_type: [
          { required: true, message: '请选择操作类型', trigger: 'change' }
        ],
        handler_type: [
          { required: true, message: '请选择处理人类型', trigger: 'change' }
        ],
        handler_role_ids: [
          { validator: this.validateRoles, trigger: 'change' }
        ],
        handler_user_ids: [
          { validator: this.validateUsers, trigger: 'change' }
        ]
      }
    }
  },

  computed: {
    /** 操作类型：隐藏执行(2)、采购(7)、入库(8)；旧数据仍显示一项便于辨认 */
    actionTypeSelectOptions () {
      const base = [
        { label: '审批', value: 1 },
        { label: '验收', value: 3 },
        { label: '付款', value: 4 },
        { label: '报价', value: 5 },
        { label: '派单', value: 6 }
      ]
      const at = this.form && this.form.action_type
      const hiddenLegacy = [2, 7, 8]
      if (at != null && hiddenLegacy.includes(at)) {
        const labels = { 2: '执行', 7: '采购', 8: '入库' }
        return [{ label: `${labels[at]}（已下线，请改选其他类型）`, value: at }, ...base]
      }
      return base
    },

    /** 报价(5)、派单(6) 不可选房东，仅平台管理员 */
    isQuoteOrDispatchAction () {
      return this.form && (this.form.action_type === 5 || this.form.action_type === 6)
    },

    rolesForHandlerSelect () {
      if (!this.form || this.form.handler_type !== 1) return []
      if (this.isQuoteOrDispatchAction) {
        return this.roleOptions.filter(r => r.id === 101)
      }
      return this.roleOptions
    },

    isEdit () {
      return !!this.node.id
    },

    availableNodes () {
      // 过滤掉当前节点和开始节点，只显示可以作为下一节点的节点
      return this.allNodes.filter(node =>
        node.id !== this.form.id &&
        node.node_type !== 1 // 开始节点不能作为下一节点
      )
    }
  },

  watch: {
    node: {
      immediate: true,
      async handler (newNode) {
        if (!newNode) return

        // 确保角色选项已加载
        if (this.roleOptions.length === 0) {
          await this.loadRoleOptions()
        }
        // 确保用户选项已加载
        if (this.userOptions.length === 0) {
          await this.loadUserOptions()
        }

        // 使用$nextTick确保DOM更新
        this.$nextTick(() => {
          this.initForm(newNode)
          // 强制更新组件
          this.$forceUpdate()
        })
      }
    }
  },

  mounted () {
    this.loadRoleOptions()
    this.loadUserOptions()
  },

  methods: {
    initForm (node) {
      console.log('初始化表单，原始节点数据:', node)

      // 使用Vue.set确保响应式
      this.$set(this, 'form', {
        id: node.id,
        node_no: node.node_no,
        node_type: node.node_type,
        node_name: node.node_name,
        node_description: node.node_description || '',
        sort: node.sort,
        is_required: node.is_required,
        action_type: node.action_type !== undefined ? node.action_type : 1,
        handler_type: node.handler_type || 1,
        handler_role_ids: node.handler_role_ids || [],
        handler_user_ids: node.handler_user_ids || [],
        require_quotation: node.require_quotation !== undefined ? node.require_quotation : 0,
        require_payment: node.require_payment || 0,
        payment_type: node.payment_type || null,
        payment_percentage: node.payment_percentage || 0,
        payment_amount: node.payment_amount || 0,
        allow_actions: Array.isArray(node.allow_actions)
          ? node.allow_actions
          : (typeof node.allow_actions === 'string' ? JSON.parse(node.allow_actions || '[]') : []),
        next_node_id: node.next_node_id || null
      })

      console.log('设置后的表单数据:', this.form)

      // 初始化角色 - 改进JSON解析逻辑
      if (node.handler_role_ids) {
        try {
          // 处理不同格式的角色ID数据
          let roleIds = []
          if (typeof node.handler_role_ids === 'string') {
            roleIds = JSON.parse(node.handler_role_ids)
          } else if (Array.isArray(node.handler_role_ids)) {
            roleIds = [...node.handler_role_ids]
          }

          // 映射原始角色ID到新的ID
          // 1 -> 101 (平台管理员)
          // 2 -> 102 (房东)
          const roleMapping = {
            1: 101,
            2: 102
          }

          this.selectedRoles = roleIds.map(id => roleMapping[id] || id).filter(id => id)
        } catch (e) {
          console.error('解析handler_role_ids失败:', e)
          this.selectedRoles = []
        }
      } else {
        this.selectedRoles = []
      }

      // 报价、派单不允许房东角色
      if (this.isQuoteOrDispatchAction) {
        this.selectedRoles = this.selectedRoles.filter(id => id === 101)
        if (this.selectedRoles.length === 0) {
          this.selectedRoles = [101]
        }
      }

      // 初始化用户 - 改进JSON解析逻辑
      if (node.handler_user_ids) {
        try {
          // 处理不同格式的用户ID数据
          if (typeof node.handler_user_ids === 'string') {
            this.selectedUsers = JSON.parse(node.handler_user_ids)
          } else if (Array.isArray(node.handler_user_ids)) {
            this.selectedUsers = [...node.handler_user_ids]
          } else {
            this.selectedUsers = []
          }
        } catch (e) {
          console.error('解析handler_user_ids失败:', e)
          this.selectedUsers = []
        }
      } else {
        this.selectedUsers = []
      }

      // 初始化允许的操作 - 改进JSON解析逻辑
      if (node.allow_actions) {
        try {
          // 处理不同格式的操作数据
          let actions = []
          if (typeof node.allow_actions === 'string') {
            actions = JSON.parse(node.allow_actions)
          } else if (Array.isArray(node.allow_actions)) {
            actions = [...node.allow_actions]
          }

          // 确保是数字数组
          this.selectedActions = actions.map(action => {
            // 如果是字符串，尝试转换为数字
            if (typeof action === 'string') {
              const num = parseInt(action)
              return isNaN(num) ? action : num
            }
            return action
          }).filter(action => {
            // 只保留有效的操作值
            return [1, 2, 3, 4].includes(action)
          })
        } catch (e) {
          console.error('解析allow_actions失败:', e)
          this.selectedActions = []
        }
      } else {
        this.selectedActions = []
      }
    },

    getNodeTypeText (type) {
      const types = {
        1: '开始节点',
        2: '审批节点',
        3: '执行节点',
        4: '验收节点',
        5: '付款节点',
        6: '结束节点',
        7: '条件节点',
        8: '并行节点'
      }
      return types[type] || '未知'
    },

    getNodeTypeTag (type) {
      const tags = {
        1: 'success',
        2: 'primary',
        3: 'warning',
        4: 'success',
        5: 'info',
        6: 'info',
        7: 'warning',
        8: 'danger'
      }
      return tags[type] || 'info'
    },

    async loadRoleOptions () {
      try {
        // 调用API获取角色列表
        // const { data } = await apiProcessGetRoles()
        // this.roleOptions = data.list || []

        // 模拟数据
        this.roleOptions = [
          { id: 101, name: '平台管理员' },
          { id: 102, name: '房东' }
        ]
      } catch (error) {
        console.error('加载角色列表失败:', error)
      }
    },

    async loadUserOptions () {
      try {
        // 调用API获取用户列表
        // const { data } = await apiProcessGetUsers()
        // this.userOptions = data.list || []

        // 模拟数据
        this.userOptions = [
          { id: 1, name: '张三' },
          { id: 2, name: '李四' },
          { id: 3, name: '王五' },
          { id: 4, name: '赵六' },
          { id: 5, name: '钱七' }
        ]
      } catch (error) {
        console.error('加载用户列表失败:', error)
      }
    },

    handleHandlerTypeChange (value) {
      // 切换处理人类型时清空其他类型的数据
      if (value !== 1) {
        this.selectedRoles = []
        this.form.handler_role_ids = '[]'
      }
      if (value !== 2) {
        this.selectedUsers = []
        this.form.handler_user_ids = '[]'
      }
      if (value !== 8) {
        this.form.handler_condition = ''
      }
      if (value === 1 && (this.form.action_type === 5 || this.form.action_type === 6)) {
        if (this.selectedRoles.length === 0) {
          this.selectedRoles = [101]
          this.handleRolesChange(this.selectedRoles)
        }
      }
    },

    handleActionTypeChange (value) {
      this.form.action_type = value
      if (value === 5 || value === 6) {
        this.selectedRoles = this.selectedRoles.filter(id => id === 101)
        this.handleRolesChange(this.selectedRoles)
        if (this.selectedRoles.length === 0) {
          this.selectedRoles = [101]
          this.handleRolesChange(this.selectedRoles)
        }
      }
      this.$forceUpdate()
    },

    handleRolesChange (roles) {
      this.form.handler_role_ids = JSON.stringify(roles)
    },

    handleUsersChange (users) {
      this.form.handler_user_ids = JSON.stringify(users)
    },

    handlePaymentChange (value) {
      if (!value) {
        this.form.payment_type = null
        this.form.payment_percentage = 0
        this.form.payment_amount = 0
      }
    },

    validateRoles (rule, value, callback) {
      if (this.form.handler_type === 1 && this.selectedRoles.length === 0) {
        callback(new Error('请选择处理角色'))
      } else {
        callback()
      }
    },

    validateUsers (rule, value, callback) {
      if (this.form.handler_type === 2 && this.selectedUsers.length === 0) {
        callback(new Error('请选择处理人员'))
      } else {
        callback()
      }
    },

    handleSubmit () {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // 处理允许的操作，确保是数组格式
          this.form.allow_actions = this.selectedActions

          // 映射新的角色ID回原始ID
          // 101 -> 1 (平台管理员)
          // 102 -> 2 (房东)
          const reverseRoleMapping = {
            101: 1,
            102: 2
          }

          let rolesForSave = [...this.selectedRoles]
          if (this.form.action_type === 5 || this.form.action_type === 6) {
            rolesForSave = rolesForSave.filter(id => id === 101)
            if (rolesForSave.length === 0) rolesForSave = [101]
          }

          const mappedRoles = rolesForSave.map(id => reverseRoleMapping[id] || id)
          const mappedUsers = this.selectedUsers // 用户ID不需要映射

          // 确保角色和用户ID以数组形式保存，而不是JSON字符串
          this.form.handler_role_ids = mappedRoles
          this.form.handler_user_ids = mappedUsers

          // 触发更新事件
          this.$emit('update', { ...this.form })
          this.$message.success('节点配置已保存')
        }
      })
    },

    handleReset () {
      this.initForm(this.node)
      this.$message.info('配置已重置')
    },

    handleDelete () {
      this.$confirm('确定删除该节点吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$emit('delete', this.form.id)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.node-config {
  padding: 10px;
  height: 100%;
  overflow-y: auto;

  .form-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
    word-wrap: break-word;
    word-break: break-all;
  }

  .form-actions {
    margin-top: 20px;
    text-align: right;

    .el-button + .el-button {
      margin-left: 10px;
    }
  }

  // 确保表单项不会超出容器宽度
  ::v-deep .el-form {
    width: 100%;
  }

  ::v-deep .el-form-item {
    margin-bottom: 16px;
    width: 100%;
  }

  ::v-deep .el-form-item__content {
    width: calc(100% - 80px); // 减去标签宽度
    min-width: 0; // 确保内容可以缩小
  }

  // 确保输入框和选择器不会超出宽度
  ::v-deep .el-input,
  ::v-deep .el-select,
  ::v-deep .el-input-number {
    width: 100%;
  }

  // 确保多选下拉框不会超出宽度
  ::v-deep .el-select-dropdown {
    max-width: 250px;
  }

  // 确保下拉框选中的项不会超出宽度
  ::v-deep .el-select__tags {
    max-width: 100%;
    overflow: hidden;
  }

  // 确保下拉框标签文本不会超出宽度
  ::v-deep .el-select__tags-text {
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  // 确保标签页内容不会超出宽度
  ::v-deep .el-tabs__content {
    width: 100%;
    overflow-x: hidden;
  }

  // 确保标签页头部不会超出宽度
  ::v-deep .el-tabs__header {
    width: 100%;
  }

  // 确保标签页项不会超出宽度
  ::v-deep .el-tabs__item {
    padding: 0 10px;
    font-size: 12px;
  }

  // 确保文本域不会超出宽度
  ::v-deep .el-textarea {
    width: 100%;
  }

  // 确保数字输入框不会超出宽度
  ::v-deep .el-input-number {
    width: 100%;

    .el-input__inner {
      text-align: left;
    }
  }

  // 确保复选框组不会超出宽度
  ::v-deep .el-checkbox-group {
    width: 100%;

    .el-checkbox {
      margin-right: 15px;
      margin-bottom: 8px;
    }
  }

  // 特别处理备注表单项，移除左边距
  .remark-form-item {
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
      padding-left: 0 !important;
      width: 100% !important;
    }
  }
}
</style>
